<template>
  <p-checkbox v-model="value"
              :name="_name"
              :disabled="_readonly"></p-checkbox>
</template>

<script>
  import mixin from './mixin';
  import PCheckbox from "src/components/UIComponents/Inputs/Checkbox.vue";

  export default {
    name: 'f-checkbox',
    mixins: [mixin],
    components: {PCheckbox},
  };
</script>



// WEBPACK FOOTER //
// f-checkbox.vue?6000d0a2